// extracted by mini-css-extract-plugin
export var icon = "_9h-3";
export var subtitle = "_9h-2";
export var title = "_9h-1";
export var value = "_9h-0";